import { render, staticRenderFns } from "./OrderRegisterPayment.vue?vue&type=template&id=2d48dd4e&"
import script from "./OrderRegisterPayment.vue?vue&type=script&lang=js&"
export * from "./OrderRegisterPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports